import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldStateDirective } from './field-state/field-state.directive';

@NgModule({
  declarations: [FieldStateDirective],
  imports: [CommonModule],
  exports: [FieldStateDirective]
})
export class DynamicDirectiveModule {}
